export const GET_GROUPS = "GET_GROUPS";
export const GET_GROUP_ID = "GET_GROUP_ID";
export const GET_AGENTS_GROUPS = "GET_AGENTS_GROUPS";

export const CREATE_GROUPS = "CREATE_GROUPS";
export const EDIT_GROUPS = "EDIT_GROUPS";
export const DELETE_GROUPS = "DELETE_GROUPS";
export const GET_SESSION_TYPE_GROUP = "GET_SESSION_TYPE_GROUP";
